var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.transaction)?_c(_vm.transactionType,{ref:"component",tag:"component",attrs:{"transaction":_vm.transaction},on:{"refreshTransaction":_vm.fetchTransaction}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }